import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    SET_INNER_OBJECTS_SELECTED: createActionType(FULL_NAMESPACE, "SET_INNER_OBJECTS_SELECTED"),
    GET_GRAPH_NODE_IMAGE_CONTENT: createActionType(FULL_NAMESPACE, "GET_GRAPH_NODE_IMAGE_CONTENT"),
    SET_READONLY_MODE: createActionType(FULL_NAMESPACE, "SET_READONLY_MODE"),
    GET_TASK_RESULT_LIMIT: createActionType(FULL_NAMESPACE, "GET_TASK_RESULT_LIMIT"),
    GET_TASK_RESULT_LIMIT_COMPLETED: createActionType(FULL_NAMESPACE, "GET_TASK_RESULT_LIMIT_COMPLETED"),
    GET_TASK_RESULT_LIMIT_REJECTED: createActionType(FULL_NAMESPACE, "GET_TASK_RESULT_LIMIT_REJECTED"),
    SAVE_TASK_RESULT_LIMIT: createActionType(FULL_NAMESPACE, "SAVE_TASK_RESULT_LIMIT"),
    SAVE_TASK_RESULT_LIMIT_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_TASK_RESULT_LIMIT_COMPLETED"),
    SAVE_TASK_RESULT_LIMIT_REJECTED: createActionType(FULL_NAMESPACE, "SAVE_TASK_RESULT_LIMIT_REJECTED")
};
